"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Page = Page;
var _react = _interopRequireDefault(require("react"));
var _reactI18next = require("react-i18next");
var _hooks = require("../../../hooks");
var _ui = require("../../ui");
var _layout = require("../layout");
var _PasswordForm = require("./PasswordForm");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function Page(_ref) {
  var CredentialsForm = _ref.credentialsForm,
    successPath = _ref.successPath;
  var _useTranslation = (0, _reactI18next.useTranslation)('libAuth'),
    t = _useTranslation.t;
  var _useSignUpWithWizard = (0, _hooks.useSignUpWithWizard)({
      successPath: successPath
    }),
    loading = _useSignUpWithWizard.loading,
    setStep = _useSignUpWithWizard.setStep,
    step = _useSignUpWithWizard.step,
    setCredentials = _useSignUpWithWizard.setCredentials,
    signUp = _useSignUpWithWizard.signUp;
  return /*#__PURE__*/_react.default.createElement(_ui.Wizard, {
    step: step,
    setStep: setStep
  }, /*#__PURE__*/_react.default.createElement(_ui.WizardStep, {
    order: 0
  }, /*#__PURE__*/_react.default.createElement(_layout.LayoutTitle, null, t('createAnAccount'))), /*#__PURE__*/_react.default.createElement(_ui.WizardStep, {
    order: 1
  }, /*#__PURE__*/_react.default.createElement(_layout.LayoutBackTitle, {
    onClick: function onClick() {
      return setStep(0);
    }
  }, t('back'))), /*#__PURE__*/_react.default.createElement(_layout.LayoutBodyWizardControl, {
    steps: 2
  }), /*#__PURE__*/_react.default.createElement(_layout.LayoutBodyCard, null, /*#__PURE__*/_react.default.createElement(_ui.CardBody, null, /*#__PURE__*/_react.default.createElement(_ui.WizardStep, {
    order: 0
  }, /*#__PURE__*/_react.default.createElement(CredentialsForm, {
    onSubmit: function onSubmit(formData) {
      setCredentials(formData);
      setStep(1);
    }
  })), /*#__PURE__*/_react.default.createElement(_ui.WizardStep, {
    order: 1
  }, /*#__PURE__*/_react.default.createElement(_PasswordForm.PasswordForm, {
    onSubmit: function onSubmit(_ref2) {
      var password = _ref2.password;
      signUp(password);
    },
    submitLoading: loading
  })))));
}